import { Template } from "./Template.js";
import { TemplateResult } from "./TemplateResult.js";
import { TemplateValue } from "./TemplateValue.js";
import { validateTemplate } from "./validateTemplate.js";

/**
 * Renders the given template. Does basic validation.
 */
export const renderTemplate = (template: Template, values: TemplateValue[]): TemplateResult => {
  const errors = validateTemplate(template, values);
  if (errors.length > 0) {
    return { type: "error", errors };
  } else {
    return template.generate(values);
  }
};
